import $ from "jquery";

const share = () => {
    $("a.share-fb").on('click', (e) => share_facebook(e));
    $("a.share-linkedin").on('click', (e) => share_linkedin(e));
    $("a.share-twitter").on('click', (e) => share_twitter(e));
}

const share_facebook = (e) => {
    e.preventDefault();
    const lien = get_permalink_attr(e.currentTarget),
        title = get_title_attr(e.currentTarget)
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${lien}&p[title]=${title}`, "pop", "width=600, height=400, scrollbars=no");
    return false;
}

const share_linkedin = (e) => {
    e.preventDefault();
    const lien = get_permalink_attr(e.currentTarget),
        title = get_title_attr(e.currentTarget)
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${lien}&title=${title}`, "pop", "width=470, height=600, scrollbars=no");
    return false;
}

const share_twitter = (e) => {
    e.preventDefault();
    const lien = get_permalink_attr(e.currentTarget),
        title = get_title_attr(e.currentTarget)
    window.open(`http://twitter.com/share?text=${title}&url=${lien}`, "pop", "width=600, height=400, scrollbars=no");
    return false;
}

const get_permalink_attr = (target) => $(target).data('permalink');
const get_title_attr = (target) => $(target).data('title');

export {share}